var HomepageCarousel, carouselIntervalInstance,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

carouselIntervalInstance = null;

module.exports = HomepageCarousel = (function() {
  function HomepageCarousel(arg) {
    var ref, ref1, showSubnavWidget;
    ref = arg != null ? arg : {}, this.carouselConfig = ref.carouselConfig, this.showFreeShippingModal = ref.showFreeShippingModal;
    this._startCarousel = bind(this._startCarousel, this);
    this.widget = $("#carousel-widget");
    this.wrapper = this.widget.find("#carousel-wrapper");
    this.length = this.wrapper.children().length - 1;
    this.index = 0;
    this.advance = true;
    if (this.carouselConfig != null) {
      ref1 = this.carouselConfig, this.carouselInterval = ref1.carouselInterval, this.numOfSlots = ref1.numOfSlots, showSubnavWidget = ref1.showSubnavWidget, this.overlayControls = ref1.overlayControls, this.maxNumOfMenuItems = ref1.maxNumOfMenuItems, this.maxNumOfMenuCols = ref1.maxNumOfMenuCols, this.moreCategoriesId = ref1.moreCategoriesId;
      this.maxNumOfSubnavItems = this.numOfSlots;
      if (showSubnavWidget) {
        this.maxNumOfSubnavItems = this.numOfSlots - 1;
      }
    }
    this.menuItemHeight = 28;
    this.menuTopPadding = 3;
    this.moreCategoriesLabel = I18n.translate('js.modules.home.more_categories');
    if (this.showFreeShippingModal) {
      this._loadFreeShippingModal();
    }
    if ($("#homepage-header").length && $("#homepage-header-temp").length) {
      $("#homepage-header-temp").children().appendTo("#homepage-header");
    }
    if (this.widget.length) {
      if (this._hasNoControls()) {
        $("#homepage-header").addClass('carousel-height-no-controls');
      } else {
        $("#homepage-header").addClass('carousel-height');
      }
    }
    if (this.widget.length) {
      this._initializeCarousel();
      if (!$('html').hasClass('lt-ie9' && this.wrapper.children().length > 1)) {
        carouselIntervalInstance = setTimeout(this._startCarousel, this.carouselInterval);
      }
      this._loadControls();
      this._loadSubnav();
    }
  }

  HomepageCarousel.prototype._hasNoControls = function() {
    return this.wrapper.children().length === 1 || this.overlayControls;
  };

  HomepageCarousel.prototype._initializeCarousel = function() {
    var child, circles;
    child = this.wrapper.children().get(0);
    if (child) {
      $(child).css("opacity", 1).css("display", "block");
    }
    circles = this.widget.find(".icon-circle");
    if (circles.length) {
      $(circles[0]).addClass("selected");
      $(circles[0]).removeClass("c-txt-gray-lt");
      return $(circles[0]).addClass("c-txt-black");
    }
  };

  HomepageCarousel.prototype._startCarousel = function() {
    this._advanceCarousel("right");
    return carouselIntervalInstance = setTimeout(this._startCarousel, this.carouselInterval);
  };

  HomepageCarousel.prototype._advanceCarousel = function(direction) {
    var prevIndex;
    prevIndex = this.index;
    this._incrementIndex(direction);
    if (prevIndex !== this.index) {
      this._showSlide(prevIndex, this.index);
      return this._showCircle(prevIndex, this.index);
    }
  };

  HomepageCarousel.prototype._jumpCarousel = function(from, to) {
    if (from !== to) {
      this._showSlide(from, to);
      this._showCircle(from, to);
      return this.index = to;
    }
  };

  HomepageCarousel.prototype._stopCarousel = function() {
    return carouselIntervalInstance = window.clearInterval(carouselIntervalInstance);
  };

  HomepageCarousel.prototype._incrementIndex = function(direction) {
    if (direction === 'right') {
      this.index += 1;
      if (this.index > this.length) {
        return this.index = 0;
      }
    } else {
      this.index -= 1;
      if (this.index < 0) {
        return this.index = this.length;
      }
    }
  };

  HomepageCarousel.prototype._showSlide = function(from, to) {
    var children;
    if (from !== to) {
      children = this.wrapper.children();
      from = $(children.get(from));
      to = $(children.get(to));
      from.fadeTo('fast', 0);
      to.fadeTo('fast', 1);
      return from.hide();
    }
  };

  HomepageCarousel.prototype._showCircle = function(from, to) {
    var circles;
    if (from !== to) {
      circles = this.widget.find(".icon-circle");
      if (circles.length) {
        $(circles[from]).removeClass("selected");
        $(circles[from]).removeClass("c-txt-black");
        $(circles[to]).addClass("selected");
        $(circles[to]).removeClass("c-txt-gray-lt");
        return $(circles[to]).addClass("c-txt-black");
      }
    }
  };

  HomepageCarousel.prototype._loadFreeShippingModal = function() {
    if (window.GIG) {
      return window.GIG.init();
    }
  };

  HomepageCarousel.prototype._loadControls = function() {
    $('.homepage-carousel-left').on('click', (function(_this) {
      return function(e) {
        _this.advance = false;
        _this._stopCarousel();
        return _this._advanceCarousel('left');
      };
    })(this));
    $('.homepage-carousel-right').on('click', (function(_this) {
      return function(e) {
        _this.advance = false;
        _this._stopCarousel();
        return _this._advanceCarousel('right');
      };
    })(this));
    $('.carousel-item, .nav-bar-item, .menu').on('mouseenter', (function(_this) {
      return function(e) {
        return _this._stopCarousel();
      };
    })(this));
    $('.carousel-item, .nav-bar-item, .menu').on('mouseleave', (function(_this) {
      return function(e) {
        _this._stopCarousel();
        if (_this.advance) {
          return carouselIntervalInstance = setTimeout(_this._startCarousel, _this.carouselInterval);
        }
      };
    })(this));
    return $('.icon-circle').on('click', (function(_this) {
      return function(e) {
        var from, ref, ref1, ref2, to;
        to = parseInt((ref = e.target) != null ? (ref1 = ref.attributes) != null ? (ref2 = ref1.getNamedItem("index")) != null ? ref2.value : void 0 : void 0 : void 0, 10);
        from = _this.index;
        if (from !== to) {
          _this._stopCarousel();
          return _this._jumpCarousel(from, to);
        }
      };
    })(this));
  };

  HomepageCarousel.prototype._numOfCols = function(numOfItems) {
    return Math.ceil(numOfItems / this.maxNumOfMenuItems);
  };

  HomepageCarousel.prototype._numOfItemsPerCol = function(numOfItems, numOfCols) {
    return Math.ceil(numOfItems / numOfCols);
  };

  HomepageCarousel.prototype._flyoutPosition = function(navBarItemPos, numOfItemsPerCol) {
    var pos;
    pos = numOfItemsPerCol <= 1 ? 0 : Math.floor(numOfItemsPerCol / 2) - 1;
    if (pos > navBarItemPos) {
      return navBarItemPos;
    } else {
      return pos;
    }
  };

  HomepageCarousel.prototype._indexStartingFromEnd = function(navBarItemPos) {
    return (this.numOfSlots - 1) - navBarItemPos;
  };

  HomepageCarousel.prototype._calculateMenuTop = function(flyoutPosition) {
    return (this.menuItemHeight * flyoutPosition) + this.menuTopPadding;
  };

  HomepageCarousel.prototype._setMenuTop = function(menu, menuHoverContainer, menuTop) {
    menu.css('top', -menuTop + 'px');
    return menuHoverContainer.css('top', -menuTop + 'px');
  };

  HomepageCarousel.prototype._repositionMenu = function(menu, menuHoverContainer, navBarItemPos, numOfItemsPerCol) {
    var flyoutPosition, menuTop, newFlyoutPos, newNavBarItemPos;
    flyoutPosition = this._flyoutPosition(navBarItemPos, numOfItemsPerCol);
    menuTop = this._calculateMenuTop(flyoutPosition);
    if (navBarItemPos < (this.numOfSlots / 2)) {
      if (flyoutPosition <= navBarItemPos) {
        this._setMenuTop(menu, menuHoverContainer, menuTop);
      }
    } else {
      newFlyoutPos = (numOfItemsPerCol - 1) - flyoutPosition;
      newNavBarItemPos = this._indexStartingFromEnd(navBarItemPos);
      if (newFlyoutPos > newNavBarItemPos) {
        flyoutPosition = (numOfItemsPerCol - 1) - newNavBarItemPos;
        menuTop = this._calculateMenuTop(flyoutPosition);
      }
      this._setMenuTop(menu, menuHoverContainer, menuTop);
    }
    return menu.addClass('flyout-pos' + flyoutPosition);
  };

  HomepageCarousel.prototype._updateMenuWidth = function(menu, numOfCols) {
    if (numOfCols > this.maxNumOfMenuCols) {
      numOfCols = this.maxNumOfMenuCols;
    }
    return menu.addClass('columns-' + numOfCols);
  };

  HomepageCarousel.prototype._createCol = function(colNum, menu, numOfItemsPerCol, menuItems) {
    var colEnd, colStart, column, j, len, menuItem, ref, results;
    menu.append("<div class='menu-column c-bdr-gray-clr'><ul></ul></div>");
    column = menu.find("ul")[colNum];
    colStart = colNum * numOfItemsPerCol;
    colEnd = colStart + numOfItemsPerCol;
    ref = menuItems.slice(colStart, colEnd);
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      menuItem = ref[j];
      results.push($(column).append(menuItem));
    }
    return results;
  };

  HomepageCarousel.prototype._createCols = function(numOfCols, menu, numOfItemsPerCol, menuItems) {
    var i, j, ref, results;
    results = [];
    for (i = j = 0, ref = numOfCols - 1; j <= ref; i = j += 1) {
      if (i === this.maxNumOfMenuCols) {
        break;
      }
      results.push(this._createCol(i, menu, numOfItemsPerCol, menuItems));
    }
    return results;
  };

  HomepageCarousel.prototype._formatMenu = function(navBarItemPos, el) {
    var menu, menuHoverContainer, menuItems, numOfCols, numOfItems, numOfItemsPerCol;
    menu = $(el).find('.menu');
    menuHoverContainer = $(el).find('.menu-hover-container');
    menuItems = menu.find('.menu-item');
    numOfItems = menuItems.length;
    numOfCols = this._numOfCols(numOfItems);
    numOfItemsPerCol = this._numOfItemsPerCol(numOfItems, numOfCols);
    this._repositionMenu(menu, menuHoverContainer, navBarItemPos, numOfItemsPerCol);
    if (numOfItems > this.maxNumOfMenuItems) {
      menu.empty();
      this._updateMenuWidth(menu, numOfCols);
      this._createCols(numOfCols, menu, numOfItemsPerCol, menuItems);
    }
    return menuHoverContainer.height(menu.outerHeight());
  };

  HomepageCarousel.prototype._appendL2Category = function(menu, itemPos, el, menuItems) {
    var bhc, li, navBarLabel, title, url;
    navBarLabel = $(el).find('.nav-bar-label');
    bhc = navBarLabel.attr('data-bhc');
    title = navBarLabel.text().trim();
    url = $(el).find('a').attr('href');
    menu.append("<li class='menu-item' data-bhc='" + bhc + "'><a href='" + url + "'>" + title + "</a></li>");
    li = $(menu.find('li')[itemPos]);
    return menuItems.push(li);
  };

  HomepageCarousel.prototype._moreCategoriesNavBarItem = function(el) {
    var moreCategoriesLabel, moreCategoriesLink;
    $(el).attr('id', this.moreCategoriesId);
    moreCategoriesLink = $(el).find('a')[0];
    $(moreCategoriesLink).removeAttr('href');
    moreCategoriesLabel = $(el).find('.nav-bar-label');
    $(moreCategoriesLabel).attr('data-bhc', 'category:' + this.moreCategoriesId);
    $(moreCategoriesLabel).attr('data-bhc-path', 'LeftNavCategories|category:' + this.moreCategoriesId);
    return $(moreCategoriesLabel).html(this.moreCategoriesLabel);
  };

  HomepageCarousel.prototype._moreCategoriesMenu = function(moreCategories) {
    var i, j, menu, menuHoverContainer, menuItems, numOfCols, numOfItems, numOfItemsPerCol, ref;
    numOfItems = moreCategories.length;
    numOfCols = this._numOfCols(numOfItems);
    numOfItemsPerCol = this._numOfItemsPerCol(numOfItems, numOfCols);
    menu = $('#' + this.moreCategoriesId).find('.menu');
    menuHoverContainer = $('#' + this.moreCategoriesId).find('.menu-hover-container');
    menu.attr('class', 'menu arrow').empty();
    menuItems = [];
    for (i = j = 0, ref = numOfItems - 1; 0 <= ref ? j <= ref : j >= ref; i = 0 <= ref ? ++j : --j) {
      this._appendL2Category(menu, i, moreCategories[i], menuItems);
    }
    this._createCols(numOfCols, menu, numOfItemsPerCol, menuItems);
    return this._repositionMenu(menu, menuHoverContainer, this.maxNumOfSubnavItems - 1, numOfItemsPerCol);
  };

  HomepageCarousel.prototype._loadSubnav = function() {
    var el, hasMoreCategories, i, j, lastl2CategorySlot, len, moreCategories, navBarItems;
    moreCategories = [];
    navBarItems = $('.nav-bar-item');
    lastl2CategorySlot = this.maxNumOfSubnavItems - 1;
    hasMoreCategories = navBarItems.length > this.maxNumOfSubnavItems;
    for (i = j = 0, len = navBarItems.length; j < len; i = ++j) {
      el = navBarItems[i];
      if (hasMoreCategories && i >= lastl2CategorySlot) {
        moreCategories.push($(el).clone());
        if (i === lastl2CategorySlot) {
          this._moreCategoriesNavBarItem(el);
        } else {
          $(el).remove();
        }
      }
      this._formatMenu(i, el);
    }
    if (moreCategories.length > 0) {
      return this._moreCategoriesMenu(moreCategories);
    }
  };

  return HomepageCarousel;

})();

//# sourceMappingURL=data:application/json;base64,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
